import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Divider,
  Button,
  Modal,
  Spin,
  message,
  Tag,
} from "antd";
import axios from "axios";

const { Title } = Typography;

const ManageNewArrival = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // For custom confirmation modal
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Fetch new arrivals
  const fetchNewArrivals = async () => {
    setLoading(true);
    try {
      const tokenString = localStorage.getItem("token");
      const response = await axios.get(
        global.config.APIURL.BaseURL + "api/NewArrival/GetNewArrivals",
        {
          headers: {
            Authorization: "Bearer " + tokenString,
          },
        }
      );
      setData(response.data || []);
    } catch (error) {
      setData([]);
      message.error("Failed to fetch new arrivals.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNewArrivals();
    checkUserActiveStatus();
  }, []);

  const checkUserActiveStatus = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          if (
            response.data.IsActive === false ||
            response.data.IsDeleted === false ||
            response.data.IsEmployee !== true // <-- Only allow if IsEmployee is true
          ) {
            alert("You are not authorized to access this page.");
            localStorage.removeItem("token");
            localStorage.removeItem("userName");
            window.location.href = "/"; // <-- Redirect to home
          }
        })
        .catch((error) => {});
    } catch (error) {}
  };
  // Open custom modal
  const handleRemove = (product) => {
    setSelectedProduct(product);
    setConfirmVisible(true);
  };

  // Confirm removal
  const handleConfirmRemove = async () => {
    if (!selectedProduct) return;
    try {
      const tokenString = localStorage.getItem("token");
      const response = await axios.post(
        global.config.APIURL.BaseURL +
          "api/NewArrival/RemoveFromNewArrival?ProductID=" +
          selectedProduct.ProductID,
        {},
        {
          headers: {
            Authorization: "Bearer " + tokenString,
          },
        }
      );
      if (response.status === 200) {
        message.success("Product removed from New Arrivals.");
        setConfirmVisible(false);
        setSelectedProduct(null);
        fetchNewArrivals();
      } else {
        message.error("Failed to remove product.");
      }
    } catch (error) {
      message.error("Error removing product.");
    }
  };

  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", padding: 8 }}>
      <Card
        style={{
          borderRadius: 16,
          boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
          background: "#fff",
          margin: 0,
        }}
        styles={{ padding: 16 }}
      >
        <Title level={2} style={{ textAlign: "center", marginBottom: 24 }}>
          Manage New Arrivals
        </Title>
        {loading ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            <Spin size="large" />
          </div>
        ) : data.length === 0 ? (
          <div style={{ textAlign: "center", color: "#888", fontSize: 18 }}>
            No new arrivals found.
          </div>
        ) : (
          data.map((category) => (
            <div key={category.Category} style={{ marginBottom: 24 }}>
              <Divider
                orientation="left"
                style={{ margin: 0, marginBottom: 8 }}
              >
                <Title level={3} style={{ margin: 0 }}>
                  {category.Category}
                </Title>
              </Divider>
              <Row gutter={[16, 16]} style={{ margin: 0 }}>
                {category.Products.map((product) => (
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    lg={6}
                    key={product.ProductID}
                    style={{ padding: 8 }}
                  >
                    <Card
                      hoverable
                      cover={
                        <img
                          alt={product.ProductName}
                          src={product.ImageUrl}
                          style={{
                            height: 180,
                            objectFit: "cover",
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                          }}
                        />
                      }
                      style={{
                        borderRadius: 8,
                        boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                        marginBottom: 0,
                      }}
                    >
                      <Title level={5} style={{ margin: 0, fontSize: 16 }}>
                        {product.ProductName}
                      </Title>
                      <div
                        style={{
                          color: "#08979c",
                          fontWeight: 600,
                          fontSize: 16,
                          margin: "8px 0",
                        }}
                      >
                        ₹{product.SalesRate?.toFixed(2)}
                      </div>
                      <div style={{ marginBottom: 8 }}>
                        <Tag
                          color={
                            product.Status === "Available" ? "green" : "red"
                          }
                        >
                          {product.Status}
                        </Tag>
                      </div>
                      <Button
                        danger
                        block
                        onClick={() => handleRemove(product)}
                        style={{ marginTop: 8 }}
                      >
                        Remove from New Arrival
                      </Button>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          ))
        )}
      </Card>
      <Modal
        open={confirmVisible}
        onCancel={() => setConfirmVisible(false)}
        onOk={handleConfirmRemove}
        okText="Yes"
        cancelText="No"
        title="Remove from New Arrival"
        centered
        destroyOnClose
        confirmLoading={loading}
      >
        {selectedProduct && (
          <div>
            Are you sure you want to remove
            <b> {selectedProduct.ProductName} </b>
            from New Arrivals?
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ManageNewArrival;
